import { useMemo } from 'react';
import { useSelector, useRangeSelector } from '../../shared/hooks';
import {
  getPeriodsOptions,
  getLastTwoMinutesOptions,
  getRorationOptions,
  getClutchGarbageOptions,
  getHomeAwayOptions,
  getConferenceOptions,
} from './filterOptions';

export function useLineupsFilter(leagueId, team, analysis) {
  const periods = usePeriodsOptionsFromTeams(leagueId, team);
  const bounds = (analysis && analysis.bounds) || {};

  const totalTime = useRangeSelector(getTotalTimeRange(bounds));
  const lastTwoMinutes = useSelector(getLastTwoMinutesOptions());
  const period = useSelector(periods);
  const rotation = useSelector(getRorationOptions());
  const clutchGarbage = useSelector(getClutchGarbageOptions());
  const totalPoints = useRangeSelector(getTotalPointsRange(bounds));
  const homeAway = useSelector(getHomeAwayOptions());
  const conference = useSelector(getConferenceOptions());
  const division = useSelector(getConferenceOptions());

  if (isNCAA(team) && division.value === undefined) {
    division.value = 'in';
  }

  return {
    totalTime,
    lastTwoMinutes,
    period,
    rotation,
    clutchGarbage,
    totalPoints,
    homeAway,
    conference,
    division,
  };
}

const isNum = x => typeof x === 'number';

function isNCAA(team) {
  const ncaaLeagues =
    team && team.leagues.filter(league => league.datasource === 'ncaa');
  return ncaaLeagues && ncaaLeagues.length > 0;
}

function getTotalTimeRange(bounds) {
  if (isNum(bounds.min_minutes) && isNum(bounds.max_minutes)) {
    return {
      min: Math.floor(bounds.min_minutes),
      max: Math.floor(bounds.max_minutes),
    };
  }
}

function getTotalPointsRange(bounds) {
  if (isNum(bounds.min_plus_minus) && isNum(bounds.max_plus_minus)) {
    return {
      min: Math.floor(bounds.min_plus_minus),
      max: Math.floor(bounds.max_plus_minus),
    };
  }
}

// Get periods options from league and team
function usePeriodsOptionsFromTeams(leagueId, team) {
  leagueId = +leagueId;
  const periods = useMemo(() => {
    if (!team) return [];
    const league = team.leagues.find(l => l.id === leagueId);
    return getPeriodsOptions(league && league.num_periods);
  }, [leagueId, team]);
  return periods;
}
